module.exports = window.moment;


//////////////////
// WEBPACK FOOTER
// external "window.moment"
// module id = 28
// module chunks = 0